import Track from '../../../utils/tracking';
import {isInApp} from '../../../utils/user-agent';
import {getSettings} from '../../selectors';
import getIsAmazonPayScriptSrcSet from './getIsAmazonPayScriptSrcSet';

export default (state) => {
  const disableIfAppAndSettingEnabled = !!(isInApp() && getSettings(state)?.should_hide_amazonpay_in_app);
  const hideIfAmazonPayScriptNotSet = !getIsAmazonPayScriptSrcSet(state);
  
  if (hideIfAmazonPayScriptNotSet) {
    Track.error('Amazonpay enabled on site but script source not set with amazonpay_script_source setting');
  }
  
  return disableIfAppAndSettingEnabled || hideIfAmazonPayScriptNotSet;
};
